module.exports = __webpack_public_path__ + "static/media/data-source-table-icon.0a3a463a.svg";